module.exports = __webpack_public_path__ + "gb-nir.5329af5915b425ea338f.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/1x1/gb-nir.svg
// module id = ../../../../flag-icon-css/flags/1x1/gb-nir.svg
// module chunks = styles